exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#partners[data-v-6f36cbc7]{margin-bottom:20px}#partners ul li[data-v-6f36cbc7]{list-style:none;display:inline-block;padding:20px 10px}#partners ul li img[data-v-6f36cbc7]{max-width:70px}#partners ul[data-v-6f36cbc7]{margin:0;padding:0;border-top:2px solid #000;margin:auto;display:flex;justify-content:space-around}#partners li[data-v-6f36cbc7]{display:flex!important;justify-content:center;flex-direction:column;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f36cbc7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/overall_layouts/partners.vue
// module id = 589
// module chunks = 0